exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-content.tasks-boards-id {\n  padding: 0;\n  max-width: 100%;\n  background: #f9fafb;\n}\n.page-content.tasks-boards-id .loggedAs {\n  margin-top: 60px;\n}\n@media screen and (min-width: 701px) {\n.page-content.tasks-boards-id {\n    padding-left: 230px;\n    padding-right: 0;\n}\n.page-content.tasks-boards-id .loggedAs {\n    margin: 0;\n}\n}\n", ""]);

// exports
